import React from "react";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import SaveIcon from "@material-ui/icons/Save";
import AddList from "./AddList";
import { Button } from "@mui/material";
import { save } from "ionicons/icons";


const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1),
        display: "flex",
        justifyContent: "flex-end",
        gap: 10
    }
}));
export default function TopBar({
    onLayoutSave,
    items,
    onRemoveItem,
    onAddItem,
    originalItems,
    allItems
}) {
    const classes = useStyles();
    return (
        <Card className={classes.root}>
            <AddList
                items={items}
                onRemoveItem={onRemoveItem}
                onAddItem={onAddItem}
                originalItems={originalItems}
                allItems={allItems}
            />
            <Button
                style={{ marginRight: 50 }}
                onClick={onLayoutSave}
                variant='contained'
                startIcon={<SaveIcon />}>
                Save
            </Button>
        </Card>
    );
}
